/**
 * i18n with lazy load functionality
 * For now the most common translations are preloaded until we remove all jquery inserts or direct dom inserts
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import ro from './ro'

// language can be changed by calling self.$i18n.locale = 'en' inside a vue component
Vue.use(VueI18n);

const messages = {
  en, ro
};

const loadedLanguages = ['en', 'ro'] // our default language that is preloaded

/**
 * Lazy Load translations
 * @param {String} lang
 */

export function setI18nLanguage (lang){
    lang = lang.substring(0, 2);
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `./${lang}`).then((msgs) => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)

        i18n.locale = lang
          document.querySelector('html').setAttribute('lang', lang)
      })
    }
        i18n.locale = lang
          document.querySelector('html').setAttribute('lang', lang)
          return Promise.resolve()

  }
  return Promise.resolve(lang)
}

export const i18n = new VueI18n({
    locale:  localStorage.language || 'en',
    fallbackLocale: 'en',
    messages,
    missing(locale, key) {
		const message = `Translation not found for locale ${locale} and key ${key}`;
		if (process.env.NODE_ENV === 'development') {
			console.warn(message)
		} else {
			// Raven.captureMessage(message, {
				// level: 'warning',
				// extra: {
					// locale: locale,
					// key: key
				// }
			// });
			return '';
		}
    }
});

export default i18n;
